import type { ReactElement } from 'react';

import { dpConfig } from 'src/config';

export function IndicatorTailwind(): ReactElement | null {
  if (['production', 'staging'].includes(`${dpConfig.env}`)) {
    return null;
  }
  return (
    <div className='pointer-events-none fixed bottom-2 left-2 z-[99] flex size-6 select-none items-center justify-center rounded-full bg-primary-default p-3 font-mono text-white text-xs shadow-md'>
      <span className='block sm:hidden'>xs</span>
      <span className='hidden sm:block md:hidden'>sm</span>
      <span className='hidden md:block lg:hidden'>md</span>
      <span className='hidden lg:block xl:hidden'>lg</span>
      <span className='hidden xl:block 2xl:hidden'>xl</span>
      <span className='hidden 2xl:block'>2xl</span>
    </div>
  );
}
